import { User } from './types'

export const addOrUpdateUser = (stateUsers: User[], usersToAdd: User[]) => {
  const unchangedUsers = stateUsers.filter(
    (t) => !usersToAdd.find(({ id }) => t.id === id)
  )
  return [...unchangedUsers, ...usersToAdd]
}
